import React from 'react';
import { render } from 'react-dom';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { compose } from 'react-komposer';
import Login from './components/login/Login';
import App from './components/app/App';
import Init from './utils/Init';
import auth from './utils/Auth';
import Info from './components/info/Info';
import Globals from './utils/Globals';
import Ajax from './utils/Ajax';
import MyDocument from './components/document/Document';
import Detail from './components/report/components/detail/Detail';

const requireAuth = (props, onData) => {
    const his = props.history;
    const loc = props.location;
    if (!auth.loggedIn()) {
        if (loc.pathname !== '/info') {
            his.replace({
                pathname: '/login',
                state: { nextPathname: loc.pathname }
            });
        }
        onData('Not Logedin', {});
    } else if (loc.pathname === '/logout') {
        auth.logout(() => {
            his.replace({
                pathname: '/login'
            });
            onData(null, {});
        });
    } else if (Globals.user === null) {
        Init.init({
            success: () => {
                Init.initAfterLogin({
                    success: () => {
                        const firstLink = Globals.actions.getFirstLink();
                        if (loc.pathname === '/' && firstLink === 'index.reports' && Globals.user.get('startReportSaved_id') !== null) {
                            his.replace({
                                pathname: '/index.reports/' + Globals.user.get('startReportSaved_id')
                            });
                        } else if (loc.pathname === '/') {
                            his.replace({
                                pathname: '/' + Globals.actions.getFirstLink()
                            });
                        }
                        onData(null, {});
                    }
                });
            }
        });
    } else {
        onData(null, {});
    }
};

class Logout extends React.Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired
    };

    componentWillMount() {
        Ajax.getJson('logout');
        auth.logout(() => {});
        this.props.history.replace({ pathname: '/login' });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            // navigated to me aga!
        }
    }

    render() {
        return null;
    }
}

const initStart = (props, onData) => {
    const myOnData = () => {
        onData(null, {});
    };
    Init.init({ success: myOnData });
};

const composeOptions = {
    errorHandler: err => (
        <p style={{ color: 'red' }}>{err}</p>
    )
};

const DocumentContainer = compose(initStart, composeOptions)(MyDocument);
render(
    (
        <Router>
            <Switch>
                <Route exact path="/login" component={compose(initStart, composeOptions)(Login)} />
                <Route exact path="/logout" component={Logout} />
                <Route exact path="/info" render={props => <DocumentContainer {...props}><Info /></DocumentContainer>} />
                <Route exact path="/report/:reportSavedId/:format/:token" render={props => <DocumentContainer closeLink="/" {...props}><Detail {...props} /></DocumentContainer>} />
                <Route path="/" component={compose(requireAuth, composeOptions)(App)} />
            </Switch>
        </Router>
    ), document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js